const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    gap: '16px',
  },
  header: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#111928',
    textAlign: 'center',
  },
  section: {
    color: '#015ffb',
  },
  title: {
    color: '#919EAB',
    fontSize: '14px',
    fontWeight: 400,
    textAlign: 'center',
  },
  texts: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
})

export default styles
